import { Link } from 'react-router-dom';
import { ArrowRight, Clock, Percent } from 'lucide-react';
import { getActiveOffers } from '../data/offers';

export const OfferBanner = () => {
  const offers = getActiveOffers();

  if (offers.length === 0) {
    return null;
  }

  return (
    <section className="section-padding bg-gradient-to-r from-primary-600 to-primary-800 text-white">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Special Offers
          </h2>
          <p className="text-lg opacity-90 max-w-2xl mx-auto">
            Don't miss out on these amazing deals. Limited time offers on selected items.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {offers.slice(0, 4).map((offer) => (
            <div
              key={offer.id}
              className="bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-6 border border-white border-opacity-20 hover:bg-opacity-20 transition-all duration-300"
            >
              <div className="flex items-center justify-center w-12 h-12 bg-white bg-opacity-20 rounded-full mb-4 mx-auto">
                <Percent className="h-6 w-6" />
              </div>
              
              <h3 className="text-xl font-semibold mb-2 text-center">
                {offer.title}
              </h3>
              
              <p className="text-sm opacity-90 text-center mb-4">
                {offer.description}
              </p>

              {offer.minOrderAmount && (
                <p className="text-xs opacity-75 text-center mb-4">
                  Min. order: ₹{offer.minOrderAmount}
                </p>
              )}

              <div className="flex items-center justify-center space-x-2 text-sm opacity-75">
                <Clock className="h-4 w-4" />
                <span>Limited Time</span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/shop?sale=true"
            className="bg-white text-primary-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors inline-flex items-center space-x-2"
          >
            <span>Shop Sale Items</span>
            <ArrowRight className="h-5 w-5" />
          </Link>
        </div>
      </div>
    </section>
  );
};
